var o={postCosmosTicket:"/api/cosmos/ticket",getVerificationRequestOptions:"/api/cosmos/get-verification-request-options"};export{o as API_URLS};
//# sourceMappingURL=constants.js.map
